import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7ee9cbda"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ImageTransformRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请选出按正确规则和顺序变化后的图形组合。每题只有1个正确答案。需注意：", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1、当图形带有多个操作符号时，根据先后顺序对图形进行连续变换；", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2、后面的操作是基于前面变化后的图形进行的。", -1));
const _hoisted_6 = {
  style: {
    "width": "600px",
    "border": "black 2px solid"
  },
  class: "pd16"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "操作规则", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr8"
}, "——", -1));
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "ml8"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mr8 ml8"
}, "——", -1));
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bothCenter sqr36 mr32 ft18",
  style: {
    "display": "inline-block"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "A")], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bothCenter sqr36 mr32 ft18",
  style: {
    "display": "inline-block"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "B")], -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bothCenter sqr36 mr32 ft18",
  style: {
    "display": "inline-block"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "C")], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bothCenter sqr36 mr32 ft18",
  style: {
    "display": "inline-block"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, "D")], -1));
const _hoisted_22 = {
  class: "flex flex-col"
};
const _hoisted_23 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_col = _resolveComponent("el-col");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  const _component_Key = _resolveComponent("Key");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4, _hoisted_5]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt16 mb16"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_row, {
      class: "bothCenter"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys($props.data.instructionBind), k => {
        return _openBlock(), _createBlock(_component_el_col, {
          span: 12,
          class: "leftCenter mt8",
          key: k
        }, {
          default: _withCtx(() => [_hoisted_8, _createElementVNode("img", {
            src: $props.data.instructionBind[k],
            class: "sqr30"
          }, null, 8, _hoisted_9), _createElementVNode("span", _hoisted_10, _toDisplayString($data.transform[k]), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })])]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.questions, (q, qi) => {
    return _openBlock(), _createBlock(_component_el_row, {
      class: "bothCenter mt16",
      key: qi
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 11,
        class: "flex justify-end items-center"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: q.init,
          class: "sqr36"
        }, null, 8, _hoisted_11), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.transforms, (t, ti) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: t + ti
          }, [_hoisted_12, _createElementVNode("img", {
            src: $props.data.instructionBind[t],
            class: "sqr36"
          }, null, 8, _hoisted_13)], 64);
        }), 128))]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 2,
        class: "leftCenter"
      }, {
        default: _withCtx(() => [_createTextVNode("   ")]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "leftCenter"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: $props.data.options['A'][qi],
          class: "sqr36 mr32",
          style: {
            "display": "inline-block"
          }
        }, null, 8, _hoisted_14), _createElementVNode("img", {
          src: $props.data.options['B'][qi],
          class: "sqr36 mr32",
          style: {
            "display": "inline-block"
          }
        }, null, 8, _hoisted_15), _createElementVNode("img", {
          src: $props.data.options['C'][qi],
          class: "sqr36 mr32",
          style: {
            "display": "inline-block"
          }
        }, null, 8, _hoisted_16), _createElementVNode("img", {
          src: $props.data.options['D'][qi],
          class: "sqr36 mr32",
          style: {
            "display": "inline-block"
          }
        }, null, 8, _hoisted_17)]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024);
  }), 128)), _createVNode(_component_el_row, {
    class: "bothCenter mt16 mb16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 13,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [_createTextVNode("   ")]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 11,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    review: $props.review,
    reviewMode: $props.reviewMode,
    options: ['A', 'B', 'C', 'D'],
    ref: "answerBtns"
  }, null, 8, ["onChoose", "review", "reviewMode"]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswerTag), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, " 您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: "34",
      color: "#3269FF",
      class: "ml32 ptr",
      onClick: _cache[0] || (_cache[0] = $event => $options.showSnapshot())
    }, {
      default: _withCtx(() => [_createVNode(_component_Key)]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("span", {
      style: {
        "color": "#3269FF"
      },
      class: "ptr",
      onClick: _cache[1] || (_cache[1] = $event => $options.showSnapshot())
    }, "查看题解")]),
    _: 1
  })) : _createCommentVNode("", true)]), _createVNode(_component_DialogCustomView, {
    title: "变换过程",
    width: "700px",
    "visible-control": $data.snapshotVisible,
    onClose: _cache[2] || (_cache[2] = $event => $data.snapshotVisible = false)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.snapshots, sp => {
        return _openBlock(), _createBlock(_component_el_row, {
          class: "flex flex-col bothCenter mr20 pd4",
          style: {
            "border": "#1388ff 1px dashed"
          },
          key: 'snp' + sp
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sp, (img, imgIdx) => {
            return _openBlock(), _createElementBlock("img", {
              key: imgIdx,
              src: img,
              class: "sqr36 mb16"
            }, null, 8, _hoisted_23);
          }), 128))]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }, 8, ["visible-control"])], 64);
}